import classes from './AuctionSchedule.module.scss';
import DashboardContentHeading from '../DashboardContentHeading/DashboardContentHeading';
import { setDay, setSites } from '../../../store/reducers/scheduleReducer';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import moment from 'moment';

const AuctionSchedule = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const schedule = {
        Monday: [],
        Tuesday: [
            { name: 'USS Yokohama', color: '#FEF9E5' },
            { name: 'USS-R Nagoya', color: '#F1EEFF' }
        ],
        Wednesday: [
            { name: 'USS Fukuoka', color: '#B0EBB4' },
            { name: 'JAA', color: '#E2F6CA' }
        ],
        Thursday: [{ name: 'USS Tokyo', color: '#E2F6CA' }],
        Friday: [
            { name: 'USS Saitama', color: '#EDE8DC' },
            { name: 'USS Nagoya', color: '#F1EEFF' },
            { name: 'USS Osaka', color: '#E1EACD' }
        ],
        Saturday: [
            { name: 'USS Gunma', color: '#DDEB9D' },
            { name: 'USS Shizuoka', color: '#ECDFCC' },
            { name: 'USS Hokuriku', color: '#FADA7A' },
            { name: 'USS Kyushu', color: '#FCE7C8' },
            { name: 'USS Okayama', color: '#F0EAAC' }
        ],
        Sunday: []
    };

    const onClickHandler = (day) => {
        let selectedDay = new Date().getDay();
        if(day === 'Monday'){
            selectedDay = new Date().getDay() === 1 ? new Date() : new Date(new Date().setDate(new Date().getDate() + (1 + (7 - new Date().getDay())) % 7));
        }else if(day === 'Tuesday'){
            selectedDay = new Date().getDay() === 2 ? new Date() : new Date(new Date().setDate(new Date().getDate() + (2 + (7 - new Date().getDay())) % 7));
        }else if(day === 'Wednesday'){
            selectedDay = new Date().getDay() === 3 ? new Date() : new Date(new Date().setDate(new Date().getDate() + (3 + (7 - new Date().getDay())) % 7));
        }else if(day === 'Thursday'){
            selectedDay = new Date().getDay() === 4 ? new Date() : new Date(new Date().setDate(new Date().getDate() + (4 + (7 - new Date().getDay())) % 7));
        }else if(day === 'Friday'){
            selectedDay = new Date().getDay() === 5 ? new Date() : new Date(new Date().setDate(new Date().getDate() + (5 + (7 - new Date().getDay())) % 7));
        }else if(day === 'Saturday'){
            selectedDay = new Date().getDay() === 6 ? new Date() : new Date(new Date().setDate(new Date().getDate() + (6 + (7 - new Date().getDay())) % 7));
        }else if(day === 'Sunday'){
            selectedDay = new Date().getDay() === 0 ? new Date() : new Date(new Date().setDate(new Date().getDate() + (7 + (7 - new Date().getDay())) % 7));
        }
        dispatch(setDay(moment(selectedDay).format('YYYY/MM/DD')));
        dispatch(setSites(schedule[day].map((site) => site.name.split(' ')[1])));
        navigate('/auction');
    }

    return (
        <div className={classes.AuctionSchedule}>
            <DashboardContentHeading iconText='auctionSchedule' />
            <table>
                <thead>
                    <tr>
                        <th colSpan="2">Schedule (Japanese Standard Time - JST)</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(schedule).map((day) => (
                        <tr key={day}>
                            <td style={{cursor:"pointer"}} className={classes.DayCell} onClick={() => onClickHandler(day)}>{day}</td>
                            <td className={classes.ScheduleCell}>
                                {schedule[day].map((event, index) => (
                                <div onClick={() => onClickHandler(day)} key={index} style={{ backgroundColor: event.color, cursor:"pointer"}}>
                                    {event.name}
                                </div>
                                ))}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className={classes.TimeZoneInfo}>
                <p>All times are in JST, 12-15 hours ahead of US time zones. Convert to your local time.</p>
            </div>
        </div>
    )
}

export default AuctionSchedule;